import { DeviceWithRegistrationInformation } from ".";
import { executeServiceCall } from "./requests";

export const systemConfigurationService = {
  async loadDeviceDetails(
    serialNumber: string | undefined,
    token: string
  ): Promise<DeviceWithRegistrationInformation | null | undefined> {
    let path =
      "./services/FormidableDesigns.Services.V1.SystemConfigurationService.LoadDeviceDetails";
    let payload = JSON.stringify({ serialNumber: serialNumber });
    return await executeServiceCall(path, payload, token);
  },
  async resetHub(
    hubID: string | undefined,
    token: string
  ): Promise<DeviceWithRegistrationInformation | null | undefined> {
    let path = "./services/FormidableDesigns.Services.V1.SystemConfigurationService.ResetHub";
    let payload = JSON.stringify({ hubID: hubID });
    return await executeServiceCall(path, payload, token);
  },
  async resetController(
    controllerID: string | undefined,
    token: string
  ): Promise<DeviceWithRegistrationInformation | null | undefined> {
    let path =
      "./services/FormidableDesigns.Services.V1.SystemConfigurationService.ResetController";
    let payload = JSON.stringify({ controllerID: controllerID });
    return await executeServiceCall(path, payload, token);
  }
};

